import { UserConstructorArgs } from '@pjn/core/model/app/User'
import { LetradoConstructorArgs } from '@pjn/core/model/app/Letrado'

export function extractUserPropsFromToken(
  info: any
): UserConstructorArgs & LetradoConstructorArgs {
  // TODO Ver el avatar
  return {
    id: info.sub,
    username: info.preferred_username,
    firstName: info.given_name,
    lastName: info.familyName,
    fullName: info.name,
    email: info.email,
    avatarUrl: undefined,
    matricula: info.matricula,
    cuil: info.cuil
  }
}
